"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityViewDto = instanceOfOrientationOpportunityViewDto;
exports.OrientationOpportunityViewDtoFromJSON = OrientationOpportunityViewDtoFromJSON;
exports.OrientationOpportunityViewDtoFromJSONTyped = OrientationOpportunityViewDtoFromJSONTyped;
exports.OrientationOpportunityViewDtoToJSON = OrientationOpportunityViewDtoToJSON;
exports.OrientationOpportunityViewDtoToJSONTyped = OrientationOpportunityViewDtoToJSONTyped;
const OrientationOpportunityViewedByNurseSource_1 = require("./OrientationOpportunityViewedByNurseSource");
/**
 * Check if a given object implements the OrientationOpportunityViewDto interface.
 */
function instanceOfOrientationOpportunityViewDto(value) {
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityViewDtoFromJSON(json) {
    return OrientationOpportunityViewDtoFromJSONTyped(json, false);
}
function OrientationOpportunityViewDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timestamp': (new Date(json['timestamp'])),
        'source': (0, OrientationOpportunityViewedByNurseSource_1.OrientationOpportunityViewedByNurseSourceFromJSON)(json['source']),
    };
}
function OrientationOpportunityViewDtoToJSON(json) {
    return OrientationOpportunityViewDtoToJSONTyped(json, false);
}
function OrientationOpportunityViewDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'timestamp': ((value['timestamp']).toISOString()),
        'source': (0, OrientationOpportunityViewedByNurseSource_1.OrientationOpportunityViewedByNurseSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=OrientationOpportunityViewDto.js.map